import { css, type Theme } from "@emotion/react";
import { typography } from "aviary-tokens";

import { animations } from "@styles";

export const radioWrapper = (theme: Theme) => css`
  display: flex;
  align-items: baseline;
  cursor: pointer;
  position: relative;
  gap: 0.5rem;

  font-size: ${theme.aviaryTypography.body.fontSize};
  font-weight: ${typography.weightBase};
`;

export const hidden = css`
  display: none;
`;

export const disabled = css`
  cursor: not-allowed;
  user-select: none;
`;

export const radio = (theme: Theme) => css`
  position: absolute;
  left: -9999px;

  & + div {
    ${animations.transition()};
    background-color: ${theme.system.backgroundBase};
  }
  /* Radio Label */
  & + div + div {
    color: ${theme.text.body};
  }
  &:hover + div + div {
    border-color: ${theme.text.emphasis};
  }

  /* Bordered outer circle */
  &:checked + div {
    border-color: ${theme.primary.backgroundActive};
  }
  &:hover + div {
    border-color: ${theme.system.borderActive};
  }
  &:focus + div {
    border-color: ${theme.system.borderFocused};
    border-width: 2px;
  }

  /* Inner, filled circle */
  &:checked + div > div {
    background-color: ${theme.primary.backgroundActive};
  }

  &[disabled] {
    & + div + div {
      color: ${theme.disabled.text};
    }
    &:hover + div + div {
      color: ${theme.disabled.text};
    }
    &:focus + div,
    &:active + div {
      box-shadow: none;
    }
  }
`;

export const circleContainer = {
  base: (theme: Theme) => css`
    ${animations.transition()};
    cursor: pointer;
    width: 16px;
    height: 16px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    gap: 0.5rem;
    border: 1px solid ${theme.system.borderActive};
  `,
  disabled: (theme: Theme) => css`
    cursor: not-allowed;
    & + div {
      cursor: not-allowed;
    }
    &&& {
      border-color: ${theme.disabled.border};
      background-color: ${theme.disabled.background};
    }
  `,
};

export const radioInner = css`
  width: 10px;
  height: 10px;
  border-radius: 100%;
`;

export const radioContent = css`
  width: 100%;
`;
